// extracted by mini-css-extract-plugin
module.exports = {"titleFont":"Unavailability_titleFont__3ZbGM"};